import { PseudoClassClasses_PseudoClass_userInvalid_72C268A9, PseudoClassClasses_PseudoClass_firstChild_72C268A9, PseudoClassClasses_PseudoClass_visited_72C268A9, PseudoClassClasses_PseudoClass_valid_72C268A9, PseudoClassClasses_PseudoClass_targetWithin_72C268A9, PseudoClassClasses_PseudoClass_target_72C268A9, PseudoClassClasses_PseudoClass_scope_72C268A9, PseudoClassClasses_PseudoClass_root_72C268A9, PseudoClassClasses_PseudoClass_required_72C268A9, PseudoClassClasses_PseudoClass_readWrite_72C268A9, PseudoClassClasses_PseudoClass_readOnly_72C268A9, PseudoClassClasses_PseudoClass_placeholderShown_72C268A9, PseudoClassClasses_PseudoClass_paused_72C268A9, PseudoClassClasses_PseudoClass_playing_72C268A9, PseudoClassClasses_PseudoClass_past_72C268A9, PseudoClassClasses_PseudoClass_outOfRange_72C268A9, PseudoClassClasses_PseudoClass_optional_72C268A9, PseudoClassClasses_PseudoClass_onlyOfType_72C268A9, PseudoClassClasses_PseudoClass_onlyChild_72C268A9, PseudoClassClasses_PseudoClass_nthLastOfType, PseudoClassClasses_PseudoClass_nthOfType, PseudoClassClasses_PseudoClass_nthLastChild, PseudoClassClasses_PseudoClass_nthChild, PseudoClassClasses_PseudoClass_link_72C268A9, PseudoClassClasses_PseudoClass_localLink_72C268A9, PseudoClassClasses_PseudoClass_lastOfType_72C268A9, PseudoClassClasses_PseudoClass_lastChild_72C268A9, PseudoClassClasses_PseudoClass_lang, PseudoClassClasses_PseudoClass_inRange_72C268A9, PseudoClassClasses_PseudoClass_invalid_72C268A9, PseudoClassClasses_PseudoClass_indeterminate_72C268A9, PseudoClassClasses_PseudoClass_hover_72C268A9, PseudoClassClasses_PseudoClass_future_72C268A9, PseudoClassClasses_PseudoClass_focusWithin_72C268A9, PseudoClassClasses_PseudoClass_focusVisible_72C268A9, PseudoClassClasses_PseudoClass_focus_72C268A9, PseudoClassClasses_PseudoClass_firstOfType_72C268A9, PseudoClassClasses_PseudoClass_enabled_72C268A9, PseudoClassClasses_PseudoClass_empty_72C268A9, PseudoClassClasses_PseudoClass_disabled_72C268A9, PseudoClassClasses_PseudoClass_current_72C268A9, PseudoClassClasses_PseudoClass_checked$0027_72C268A9, PseudoClassClasses_PseudoClass_blank_72C268A9, PseudoClassClasses_PseudoClass_anyLink_72C268A9, PseudoClassClasses_PseudoClass_active_72C268A9 } from "../Types/PseudoClass.fs.js";

export function Active(rules) {
    return PseudoClassClasses_PseudoClass_active_72C268A9(rules);
}

export function AnyLink(rules) {
    return PseudoClassClasses_PseudoClass_anyLink_72C268A9(rules);
}

export function Blank(rules) {
    return PseudoClassClasses_PseudoClass_blank_72C268A9(rules);
}

export function Checked(rules) {
    return PseudoClassClasses_PseudoClass_checked$0027_72C268A9(rules);
}

export function Current(rules) {
    return PseudoClassClasses_PseudoClass_current_72C268A9(rules);
}

export function Disabled(rules) {
    return PseudoClassClasses_PseudoClass_disabled_72C268A9(rules);
}

export function Empty(rules) {
    return PseudoClassClasses_PseudoClass_empty_72C268A9(rules);
}

export function Enabled(rules) {
    return PseudoClassClasses_PseudoClass_enabled_72C268A9(rules);
}

export function FirstOfType(rules) {
    return PseudoClassClasses_PseudoClass_firstOfType_72C268A9(rules);
}

export function Focus(rules) {
    return PseudoClassClasses_PseudoClass_focus_72C268A9(rules);
}

export function FocusVisible(rules) {
    return PseudoClassClasses_PseudoClass_focusVisible_72C268A9(rules);
}

export function FocusWithin(rules) {
    return PseudoClassClasses_PseudoClass_focusWithin_72C268A9(rules);
}

export function Future(rules) {
    return PseudoClassClasses_PseudoClass_future_72C268A9(rules);
}

export function Hover(rules) {
    return PseudoClassClasses_PseudoClass_hover_72C268A9(rules);
}

export function Indeterminate(rules) {
    return PseudoClassClasses_PseudoClass_indeterminate_72C268A9(rules);
}

export function Invalid(rules) {
    return PseudoClassClasses_PseudoClass_invalid_72C268A9(rules);
}

export function InRange(rules) {
    return PseudoClassClasses_PseudoClass_inRange_72C268A9(rules);
}

export function Lang(language, rules) {
    return PseudoClassClasses_PseudoClass_lang(language, rules);
}

export function LastChild(rules) {
    return PseudoClassClasses_PseudoClass_lastChild_72C268A9(rules);
}

export function LastOfType(rules) {
    return PseudoClassClasses_PseudoClass_lastOfType_72C268A9(rules);
}

export function LocalLink(rules) {
    return PseudoClassClasses_PseudoClass_localLink_72C268A9(rules);
}

export function Link(rules) {
    return PseudoClassClasses_PseudoClass_link_72C268A9(rules);
}

export function NthChild(n, rules) {
    return PseudoClassClasses_PseudoClass_nthChild(n, rules);
}

export function NthLastChild(n, rules) {
    return PseudoClassClasses_PseudoClass_nthLastChild(n, rules);
}

export function NthOfType(n, rules) {
    return PseudoClassClasses_PseudoClass_nthOfType(n, rules);
}

export function NthLastOfType(n, rules) {
    return PseudoClassClasses_PseudoClass_nthLastOfType(n, rules);
}

export function OnlyChild(rules) {
    return PseudoClassClasses_PseudoClass_onlyChild_72C268A9(rules);
}

export function OnlyOfType(rules) {
    return PseudoClassClasses_PseudoClass_onlyOfType_72C268A9(rules);
}

export function Optional(rules) {
    return PseudoClassClasses_PseudoClass_optional_72C268A9(rules);
}

export function OutOfRange(rules) {
    return PseudoClassClasses_PseudoClass_outOfRange_72C268A9(rules);
}

export function Past(rules) {
    return PseudoClassClasses_PseudoClass_past_72C268A9(rules);
}

export function Playing(rules) {
    return PseudoClassClasses_PseudoClass_playing_72C268A9(rules);
}

export function Paused(rules) {
    return PseudoClassClasses_PseudoClass_paused_72C268A9(rules);
}

export function PlaceholderShown(rules) {
    return PseudoClassClasses_PseudoClass_placeholderShown_72C268A9(rules);
}

export function ReadOnly(rules) {
    return PseudoClassClasses_PseudoClass_readOnly_72C268A9(rules);
}

export function ReadWrite(rules) {
    return PseudoClassClasses_PseudoClass_readWrite_72C268A9(rules);
}

export function Required(rules) {
    return PseudoClassClasses_PseudoClass_required_72C268A9(rules);
}

export function Root(rules) {
    return PseudoClassClasses_PseudoClass_root_72C268A9(rules);
}

export function Scope(rules) {
    return PseudoClassClasses_PseudoClass_scope_72C268A9(rules);
}

export function Target(rules) {
    return PseudoClassClasses_PseudoClass_target_72C268A9(rules);
}

export function TargetWithin(rules) {
    return PseudoClassClasses_PseudoClass_targetWithin_72C268A9(rules);
}

export function Valid(rules) {
    return PseudoClassClasses_PseudoClass_valid_72C268A9(rules);
}

export function Visited(rules) {
    return PseudoClassClasses_PseudoClass_visited_72C268A9(rules);
}

export function FirstChild(rules) {
    return PseudoClassClasses_PseudoClass_firstChild_72C268A9(rules);
}

export function UserInvalid(rules) {
    return PseudoClassClasses_PseudoClass_userInvalid_72C268A9(rules);
}

